<div class="overview">
	<div class="tasks">
		@for (item of controllerTasks; track item) {
			<div class="overview-header">
				<h2>{{ item.title }}</h2>
				<span>{{ item.description }}</span>
			</div>
			<div>
				@for (task of item.items; track task) {
					<div class="line-item">
						<div>{{ task.label }}</div>
						<mat-checkbox [(ngModel)]="taskValues[item.id +'.'+task.id]"
						              (ngModelChange)="setValue(item.id,task.id,$event)"></mat-checkbox>
					</div>
				}
			</div>
		}
	</div>

	<div class="overview-panel">
		<h2>Overview</h2>
		<div class="sub">Intake progress</div>
		<div class="progress-bar">
			<mat-progress-bar class="progress" mode="determinate" [value]="progressAmount"></mat-progress-bar>
			<div class="amount">{{ progressAmount }}%</div>
		</div>

		<div class="section">
			<div class="progress-bar">
				<div class="task-name">Info</div>
				<intake-status-pill [status]="getStatus('info')"></intake-status-pill>
			</div>
			<div class="progress-bar">
				<div class="task-name">Docs</div>
				<intake-status-pill [status]="getStatus('doc')"></intake-status-pill>
			</div>
			<div class="progress-bar">
				<div class="task-name">ID</div>
				<intake-status-pill [status]="getStatus('id')"></intake-status-pill>
			</div>
			<div class="progress-bar">
				<div class="task-name">Insurance</div>
				<intake-status-pill [status]="getStatus('insurance')"></intake-status-pill>
			</div>
			<div class="progress-bar">
				<div class="task-name">Payment</div>
				<intake-status-pill [status]="getStatus('payment')"></intake-status-pill>
			</div>
		</div>

		<div class="section">
			<div class="sub">Basic Information</div>
			<div class="progress-bar">
				<div class="task-name">Full name</div>
				<div>{{ patient.first_name }} {{ patient.last_name }}</div>
			</div>
			<div class="progress-bar">
				<div class="task-name">Preferred name</div>
				<div>{{ this.patientInfo.data[SurveyQuestions.PreferredName] }}</div>
			</div>
			<div class="progress-bar">
				<div class="task-name">Date of birth</div>
				<div>{{ patient.birthdate | orgDate: 'yyyy-MM-dd' }}</div>
			</div>
			<div class="progress-bar">
				<div class="task-name">Sex</div>
				<div>{{ patient.sex }}</div>
			</div>
			<div class="progress-bar">
				<div class="task-name">Preferred language</div>
				<div>{{ this.patientInfo.data[SurveyQuestions.PrimaryLanguage] }}</div>
			</div>
		</div>

		<div class="section">
			<div class="sub">Contact</div>
			<div class="progress-bar">
				<div class="task-name">Phone</div>
				<div class="phone-div">
					<div>
						<div class="phone-cell">Cell</div>
						<div class="phone">{{ patient.phone || "N/A" }}</div>
					</div>

					<div>
						<div class="phone-cell">Home</div>
						<div class="phone">{{ this.patientInfo.data[SurveyQuestions.HomePhone] || "N/A" }}</div>
					</div>
				</div>
			</div>
			<div class="progress-bar">
				<div class="task-name">Email</div>
				<div>{{ patient.email || "N/A" }}</div>
			</div>
		</div>
	</div>
</div>
